import { render, staticRenderFns } from "./app-notification-bell.vue?vue&type=template&id=24899246"
import script from "./app-notification-bell.vue?vue&type=script&lang=ts"
export * from "./app-notification-bell.vue?vue&type=script&lang=ts"
import style0 from "./app-notification-bell.vue?vue&type=style&index=0&id=24899246&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24899246')) {
      api.createRecord('24899246', component.options)
    } else {
      api.reload('24899246', component.options)
    }
    module.hot.accept("./app-notification-bell.vue?vue&type=template&id=24899246", function () {
      api.rerender('24899246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-notification-bell/app-notification-bell.vue"
export default component.exports